import { notificacaoErro } from "../app/notificacao";

async function alteraSenhaPost(senha, novaSenha, token) {
  const url = new URL(process.env.REACT_APP_API_URL + "/usuario/alterar-senha");
  const init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      senha,
      novaSenha,
    }),
  };

  const fet = await fetch(url, init);

  switch (fet.status) {
    case 200:
      return { success: true, status: fet.status, data: await fet.json() };
    case 404:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro ao alterar a senha."),
      };
    default:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro inesperado ao alterar a senha."),
      };
  }
}

const alteraSenha = { alteraSenhaPost };

export default alteraSenha;
